<template>
  <div id="Warehousetable">
    <el-table
      ref="tableRef"
      :data="tableData"
      @row-dblclick="rowdblclick"
      @cell-click="cellclick"
      @header-dragend="headerdragend"
      border
      style="width: 100%;"
      :height="heights==true?tableHeight:'300'"
      class="tabone_sty"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0'}"
    >
      <el-table-column width="80" height="500" align="center" prop="BarCode" fixed="left">
        <template slot="header">
          <i :class="isInners" @click="clickIcon" style="color:#2594ff;font-size:18px"></i>
        </template>
        <template slot-scope="scope">{{scope.$index+1 }}</template>
      </el-table-column>
      <el-table-column width="80" align="center" label="类型">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
            style="color:#e9cb70;font-size:18px"
          ></i>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="table_columns" width="50" align="center" label="类型">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
            style="color:#e9cb70;font-size:18px"
          ></i>
        </template>
      </el-table-column>-->
      <template v-for="(obj,index) in ObtainHeader">
        <el-table-column
          :width="obj.Width==''?'':obj.Width"
          align="center"
          :index="index"
          :key="index"
          :prop="obj.Key"
          :label="obj.Rename"
          v-if="obj.Show"
        >
          <template slot-scope="scope">
            <div class="input_box ub ub-ac">
              <input
                size="mini"
                v-if="(scope.row.IsDir!==1&& arrayVals && IsWrites!== 1 && scope.row.CostType!=1)
                &&(obj.Key=='Total'
                 ||obj.Key=='Price'||obj.Key=='IniARTotal'||obj.Key=='Total00')"
                type="text"
                ref="IniAR"
                :id="'x_'+scope.$index+'y_'+index"
                class="input_stys"
                v-model="scope.row[obj.Key]"
                @keydown.enter="EnterArrow(scope.$index,index)"
                @blur="changeData(scope.row,scope.$index,obj.Key,scope.row[obj.Key])"
                @focus="inputFocus(scope.row[obj.Key])"
              />
              <div
                v-else-if="(scope.row.IsDir!==1&& arrayVals && IsWrites!== 1 )
                &&(obj.Key=='Qty')"
                @dblclick="clickAbove(scope.row,scope.$index)"
                style="width: 100%;height: 100%;"
              >
                <input
                  size="mini"
                  v-if="(scope.row.IsDir!==1&& arrayVals && IsWrites!== 1 )
                &&(obj.Key=='Qty')&& (scope.row.CostType ==0 && scope.row.IsSerial  ==0)"
                  type="text"
                  ref="IniAR"
                  :id="'x_'+scope.$index+'y_'+index"
                  class="input_stys"
                  v-model="scope.row[obj.Key]"
                  @keydown.enter="EnterArrow(scope.$index,index)"
                  @blur="changeData(scope.row,scope.$index,obj.Key,scope.row[obj.Key])"
                  @focus="inputFocus(scope.row[obj.Key])"
                />

                <div v-else class="only_show_div">{{scope.row[obj.Key]}}</div>
                <span
                  v-if="(scope.row.IsDir!==1&& arrayVals && IsWrites!== 1 )
                &&(obj.Key=='Qty')"
                  class="cliclicon el-icon-more"
                  @click="clickAbove(scope.row,scope.$index)"
                ></span>
              </div>
              <div v-else class="only_show_div">{{scope.row[obj.Key]}}</div>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPages"
      :page-sizes="[20,50,100]"
      :page-size="pageSizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
    <SerialTable
      ref="SerialTable"
      :show.sync="SerialTableShow"
      :pargam="pargam"
      :vchtype="1"
      :qtys="qtys"
      :tableDatasl="tableDatasl"
      :tableDatarow="tableDatarow"
      @chooseBack="Databackfilling"
    />
    <!-- 期初录入批次 -->
    <AddBatchDialog
      :show.sync="AddBatchShow"
      :tableData="tableDataBatch"
      @chooseBack="AddBatchchooseBack"
    />
    <!-- 期初录入序列号 -->
    <coloursequence
      :show.sync="coloursequenceShow"
      :tableData="tableDataBatch"
      @chooseBack="coloursequencechooseBack"
    />
    <MultipleRiod
      :show.sync="MultipleRiodShow"
      :tableData="tableDataBatch"
      @chooseBack="MultipleRiodchooseBack"
    />
  </div>
</template>

<script>
import tool from "@/utils/tool";
// import session from "../../../utils/session";
// import tool from "@/utils/tool";
export default {
  name: "Warehousetable",
  data() {
    return {
      MultipleRiodShow: false, // 多单位数量
      coloursequenceShow: false, // 新增序列号弹框是否显示
      rowIndex: 0,
      AddBatchShow: false, //新增批次弹框是否显示
      qtys: "0.00", // 数量合计
      tableDatasl: [], // 数量数据
      tableDatarow: {}, // 数量当前数据
      SerialTableShow: false, // 序列号 颜色 备注录入弹框
      tableDataBatch: {}, // 手工指定商品
      tableHeight: window.innerHeight - 300 + "px",
      pargams: this.pargam,
      heightss: this.heights,
      isInner: this.isInners,
      asdaaf: true,
      data: this.tableData,
      icons: false,
      icon: false,
      column: this.columnS,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pageSizes, //每页显示数量
      // tableData: [],
      img: this.imgs,
      // filetext: require("../../assets/images/icon_set.png"),
      filetext: "",
      FullNameName: "",
      file: "",
      Discontext: true,
      Discontexts: "",
      Discon: [],
      taData: [],
      taData1: this.ObtainHeader,
      table_columns: this.table_column,
      IsWrite: this.IsWrites
    };
  },
  props: {
    IsWrites: Number,
    table_column: {
      type: Boolean,
      default: true
    },
    tableData: Array,
    ObtainHeader: Array,
    currentPages: Number,
    totals: Number,
    pageSizes: Number,

    imgs: String,
    heights: {
      type: Boolean
    },
    columnS: {
      type: Boolean,
      default: true
    },
    pargam: Object,
    isInners: {
      type: String
    }
  },
  computed: {
    arrayVals() {
      return this.circulate("修改").Status;
    }
  },
  methods: {
    
    // 点击单元格
    cellclick({ row, $rowIndex, columnIndex, column }) {
      //  this.rowIndex = $rowIndex;
    },
    // 新增多单位数量数据回填
    MultipleRiodchooseBack(data, Totals) {
      this.tableData[this.rowIndex].Qty = Totals;
      this.tableData[this.rowIndex].QtyData = data;
    },
    // 新增序列号数据回填
    coloursequencechooseBack(data, QTYs, Totals, Prices) {
      this.tableData[this.rowIndex].Qty = QTYs;
      this.tableData[this.rowIndex].Total = Totals;
      this.tableData[this.rowIndex].Price = Number(Prices);
      this.tableData[this.rowIndex].QtyData = data;
      this.$emit("changeData", this.tableData[this.rowIndex]);
    },
    // 新增批次数据回填
    AddBatchchooseBack(data, QTYs, Totals, Prices) {
      this.tableData[this.rowIndex].Qty = QTYs;
      this.tableData[this.rowIndex].Total = Totals;
      this.tableData[this.rowIndex].Price = Number(Prices);
      this.tableData[this.rowIndex].QtyData = data;
      this.$emit("changeData", this.tableData[this.rowIndex]);
    },
    // 期初数量弹框数据回填
    Databackfilling(qty, vchtype, Total, Qtys) {
      this.tableData[this.rowIndex].Qty = qty.length;
      this.tableData[this.rowIndex].QtyData = qty;
      this.changeData(
        this.tableData[this.rowIndex],
        this.rowIndex,
        "Qty",
        qty.length
      );
    },
    // 点击数量
    clickAbove(row, rowIndex) {
      this.rowIndex = rowIndex;
      // 如果商品CostType =1,IsSerial =1
      // 批次
      // 到期日期
      // 生产日期
      // 单价
      // 序列号
      // 颜色
      // 备注
      if (row.CostType == 1 && row.IsSerial == 1) {
        this.tableDataBatch = row;
        this.coloursequenceShow = true;
      }
      // 直接输入 多单位
      if (row.CostType == 0 && row.IsSerial == 0) {
        this.tableDataBatch = row;
        this.MultipleRiodShow = true;
      }
      // 批次
      // 到期日期
      // 生产日期
      // 数量
      // 单价
      // 金额

      if (row.CostType == 1 && row.IsSerial == 0) {
        this.tableDataBatch = row;
        this.AddBatchShow = true;
      }
      // 序列号
      // 颜色
      // 备注

      if (row.CostType == 0 && row.IsSerial == 1) {
        // console.log(row);
        // return;
        this.tableDatasl = row.QtyData;
        this.SerialTableShow = true;
      }
    },
    distinctObj(numberArr, ind) {
      let obj = "";
      for (var i of numberArr) {
        if (i.id == ind) {
          obj = i;
          return obj;
        }
      }
      return false;
    },
    EnterArrow(rowindex, index) {
      // console.log(this.ObtainHeader.length);

      // if (!this.distinctObj(this.$refs.IniAR, `x_${rowindex}y_${index + 1}`)) {
      //   rowindex = rowindex +1
      // } this.distinctObj(this.$refs.IniAR, `x_${rowindex}y_${index + 1}`).focus();
      for (let i = index + 1; i < this.ObtainHeader.length + 1; i++) {
        if (
          this.distinctObj(this.$refs.IniAR, `x_${rowindex}y_${i}`) !== false
        ) {
          setTimeout(() => {
            this.distinctObj(this.$refs.IniAR, `x_${rowindex}y_${i}`).focus();
            this.distinctObj(this.$refs.IniAR, `x_${rowindex}y_${i}`).select();
          }, 300);
          return;
        }

        if (i + 1 == this.ObtainHeader.length + 1) {
          rowindex = rowindex + 1;
          for (let j = 1; j < this.ObtainHeader.length + 1; j++) {
            if (
              this.distinctObj(this.$refs.IniAR, `x_${rowindex}y_${j}`) !==
              false
            ) {
              this.distinctObj(this.$refs.IniAR, `x_${rowindex}y_${j}`).focus();
              this.distinctObj(
                this.$refs.IniAR,
                `x_${rowindex}y_${j}`
              ).select();
              return;
            }
          }
        }
      }
    },
    headerdragend(newWidth, oldWidth, column, event) {
      let Baseno = false;
      this.ObtainHeader.map(item => {
        if (item.Key == column.property) {
          Baseno = item.BaseNo;
          return;
        }
      });
      if (Baseno != false) {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          Model: this.pargam.Model,
          data: [
            {
              BaseNo: Baseno,
              Width: newWidth
            }
          ]
        };
        this.request
          .post("/index/Settings/modify_function_fields", {
            jparams: JSON.stringify(jparams)
          })
          .then(res => {})
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 遍历权限
    ergodics(name) {
      let obj = [];
      let array = tool.getLocal("Button_Power");
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        obj.push(element);
        if (element.Name == name) {
          return obj[obj.length - 1];
        }
      }
    },
    // 遍历权限
    circulate(name) {
      // console.log(this.pargams.name);
      let array = this.ergodics(this.pargams.name).List;
      let obj = [];
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        obj.push(element);
        if (element.Action == name) {
          return obj[obj.length - 1];
        }
      }
    },
    // 双击一行
    rowdblclick(obj) {
      this.$emit("dblclick", obj);
    },
    clickIcon() {
      this.$emit("clickIcon");
    },
    handleSizeChange(val) {
      // 赋值
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      // 赋值
      this.$emit("handleCurrentChange", val);
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // aseggfg(arg1, arg2, fix) {
    //   if (!parseInt(fix) == fix) {
    //     return;
    //   }
    //   var m = 0,
    //     s1 = arg1.toString(),
    //     s2 = arg2.toString();
    //   try {
    //     m += s1.split(".")[1].length;
    //   } catch (e) {}
    //   try {
    //     m += s2.split(".")[1].length;
    //   } catch (e) {}
    //   if (m > fix) {
    //     return (
    //       Math.round(
    //         (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
    //           Math.pow(10, m - fix)
    //       ) * Math.pow(10, fix)
    //     );
    //   } else if (m <= fix) {
    //     return (
    //       (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
    //       Math.pow(10, m)
    //     ).toFixed(fix);
    //   } else {
    //     return arg1 / arg2; //.toFixed(fix);
    //   }
    // },
    // 数量、单价、金额联动
    changeData(data, index, field, name) {
      if (this.FullNameName != name) {
        setTimeout(() => {
          switch (field) {
            case "Qty":
              if (
                (data.Price == 0 || data.Price == "") &&
                data.Qty != 0 &&
                data.Qty != ""
              ) {
                data.Price = (Number(data.Total) / Number(data.Qty)).toFixed(
                  tool.getLocal("get_config").moneyPoint
                );
              } else if (
                (data.Qty != 0 || data.Qty != "") &&
                (data.Price != 0 || data.Price != "")
              ) {
                data.Total = tool.accMul(
                  Number(data.Qty),
                  Number(data.Price),
                  tool.getLocal("get_config").moneyPoint
                );
              }
              break;
            case "Total":
              if (
                (data.Qty == 0 || data.Qty == "") &&
                data.Price != 0 &&
                data.Price != ""
              ) {
                data.Qty = this.aseggfg(
                  Number(data.Total),
                  Number(data.Price),
                  tool.getLocal("get_config").moneyPoint
                );
              } else if (data.Qty != 0 && data.Qty != "") {
                data.Price = (Number(data.Total) / Number(data.Qty)).toFixed(
                  tool.getLocal("get_config").moneyPoint
                );
              }
              break;
            case "Price":
              if (
                (data.Qty == 0 || data.Qty == "") &&
                data.Price != 0 &&
                data.Price != ""
              ) {
                data.Qty = this.aseggfg(
                  Number(data.Total),
                  Number(data.Price),
                  tool.getLocal("get_config").moneyPoint
                );
              } else if (
                (data.Qty != 0 || data.Qty != "") &&
                (data.Price != 0 || data.Price != "")
              ) {
                data.Total = tool.accMul(
                  Number(data.Qty),
                  Number(data.Price),
                  tool.getLocal("get_config").moneyPoint
                );
                // console.log(data.Total);
                // * ;
              }
              break;
            case "IniARTotal":
              break;
            default:
              break;
          }
          data[field] = Number(data[field]).toFixed(
            tool.getLocal("get_config").moneyPoint
          );
          this.$emit("changeData", data, index, field);
        }, 20);
      }
    },
    aseggfg(arg1, arg2, fix) {
      if (!parseInt(fix) == fix) {
        return;
      }
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      if (m > fix) {
        return (
          Math.round(
            (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
              Math.pow(10, m - fix)
          ) * Math.pow(10, fix)
        );
      } else if (m <= fix) {
        return (
          (Number(s1.replace(".", "")) / Number(s2.replace(".", ""))) *
          Math.pow(10, m)
        ).toFixed(fix);
      } else {
        return arg1 / arg2; //.toFixed(fix);
      }
    },
    // 聚焦选中input全部
    inputFocus(data, i) {
      this.FullNameName = data;
      event.currentTarget.select();
    },
    handleClick(obj) {
      this.$emit("handleClick", obj);
    },

    deleteClick(index) {
      this.$emit("deleteClick", index);
    },
    Discontinuation(data, index) {
      this.$emit("Discontinuation", data, index);
    }
  },
  created() {
    // console.log("表格", this.IsWrites);
    // console.log(this.$attrs.pargam);
  },
  watch: {
    ObtainHeader: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
.el-table--medium td,
.el-table--medium th {
  height: 30px;
  line-height: 30px;
  padding: 0;
  text-align: center;
}
.el-table .cell {
  white-space: nowrap;
  text-align: center;
  padding: 0;
}
#Warehousetable .el-input--mini .el-input__inner {
  height: 30px;
  line-height: 30px;
  border-radius: 0;
}
.el-table__fixed-header-wrapper {
  z-index: 25;
}
.btn {
  border: none;
  background-color: transparent;
  color: #409eff;
  font-size: 12px;
  margin-right: 15px;
  padding: 7px 0;
}
.only_show_div {
  width: 100%;
  text-align: center;
}
.tabone_sty {
  .input_stys {
    height: 30px;
    width: 100%;
    display: block;
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    padding: 0 !important;
    background: #fff;
    display: block;
    box-sizing: border-box;
    padding: 0 0;
    border: 0; //可根据需要修改有无边框显示长度和宽带
    overflow: hidden;
    // outline: none;
    text-align: center;
  }
}
.el-table .cell {
  white-space: nowrap;
}
.cliclicon {
  position: absolute;
  top: 5px;
  right: 9px;
  // display: none;
}

.cliclicon:hover {
  color: #0881f3;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
/deep/ .el-table td,
.el-table th {
  padding: 0;
}
/deep/ .el-table .cell,
.el-table th div,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Table/Earlystage/Earlystage.vue